import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BsPencilFill, BsTrashFill } from 'react-icons/bs';
import Header from '../../components/Header';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import axios from '../../Axiosinstance';

import { Link, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import Pagination from 'react-bootstrap/Pagination';
import {
  Box,
  Button,
  FormControl,Typography,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper
} from '@mui/material';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaPlus } from 'react-icons/fa';
import { Container } from 'react-bootstrap';


import FeedbackChartModal from './FeedbackChartModal';
import * as XLSX from 'xlsx';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  button: {
    whiteSpace: "nowrap", // Prevents text from breaking
    padding: "10px 15px",
    fontSize: "14px",
    minWidth: "120px", // Ensures button stays visible
    textAlign: "center",
  },
};



const NestedModal = ({ showNestedModal, handleCloseNestedModal, detailedFeedback }) => {
  return (
    <Modal show={showNestedModal} onHide={handleCloseNestedModal} dialogClassName="modal-fullscreen">
      <Modal.Header closeButton>
        <Modal.Title>Feedback Answers</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {detailedFeedback && detailedFeedback.length > 0 && ( // Add a check for detailedFeedback
          <div>
            <h5>Student: {detailedFeedback[0].studentName}</h5> {/* Access studentName from the first element */}
            <TableContainer component={Paper} elevation={3}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Question</strong></TableCell>
                    <TableCell><strong>Answer</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Section A Header */}
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Typography variant="subtitle1" fontWeight="bold">Section A</Typography>
                    </TableCell>
                  </TableRow>

                  {detailedFeedback[0].questions.map((question, index) => {
                    if (index === 5) {
                      return (
                        <React.Fragment key={index}>
                          <TableRow>
                            <TableCell colSpan={2}>
                              <Typography variant="subtitle1" fontWeight="bold">Section B</Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>{question}</TableCell>
                            <TableCell>{detailedFeedback[0].answers[index]}</TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    }

                    if (index === 11) {
                      return (
                        <React.Fragment key={index}>
                          <TableRow>
                            <TableCell colSpan={2}>
                              <Typography variant="subtitle1" fontWeight="bold">Section C</Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>{question}</TableCell>
                            <TableCell>{detailedFeedback[0].answers[index]}</TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    }

                    return (
                      <TableRow key={index}>
                        <TableCell>{question}</TableCell>
                        <TableCell>{detailedFeedback[0].answers[index]}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      </Modal.Body>
      {/* ✅ Footer with aligned button */}
      <Modal.Footer style={{ justifyContent: 'flex-end' }}>
        <Button variant="contained" onClick={handleCloseNestedModal}>
          Close
        </Button>
      </Modal.Footer>

    </Modal>
  );
};



const App = () => {
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [batchCodes, setBatchCodes] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState('');
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [feedbackData, setFeedbackData] = useState([]);
  const [selectedBatchFeedback, setSelectedBatchFeedback] = useState([]);
  const [fetchedFeedback, setFetchedFeedback] = useState([]);
  const [feedbackId, setFeedbackId] = useState('');
  const [studentId, setStudentId] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showNestedModal, setShowNestedModal] = useState(false);
  const [moduleDetails, setModuleDetails] = useState([]);
  const [moduleName, setModuleName] = useState('');
  const [dateTaken, setDateTaken] = useState('');
  const [lectureName, setLectureName] = useState('');

  const [detailedFeedback, setDetailedFeedback] = useState([]);
  const [selectedFeedback, setSelectedFeedback] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [allstudentsfeedbackresponse, setAllstudentsfeedbackresponse] = useState('');
  const [filteredFeedback, setFilteredFeedback] = useState([]); // New state for filtered feedback



  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };


  const [feedbackChartData, setFeedbackChartData] = useState([]);

  const [totalfeedbacksansweredcount, setTotalFeedbacksAnsweredCount] = useState([]);

  useEffect(() => {
    // Fetch data for FeedbackChartModal when the component mounts or when necessary
    axios.get('generalfeedback/stats')
      .then(response => {
        setFeedbackChartData(response.data);
      })
      .catch(error => {
        console.error('Error fetching feedback chart data:', error);
      });
  }, []);



  useEffect(() => {
    // Fetch data for FeedbackChartModal when the component mounts or when necessary
    axios.get('generalfeedback/gettotalcount')
      .then(response => {
        setTotalFeedbacksAnsweredCount(response.data);
      })
      .catch(error => {
        console.error('Error fetching feedback chart data:', error);
      });
  }, []);


  useEffect(() => {
    // Fetch data for FeedbackChartModal when the component mounts or when necessary
    axios.get('generalfeedback/')
      .then(response => {
        setAllstudentsfeedbackresponse(response.data);
        console.log(response.data);
      })
      .catch(error => {
        console.error('Error fetching feedback chart data:', error);
      });
  }, []);

  useEffect(() => {
    // Set filteredFeedback initially to fetchedFeedback
    setFilteredFeedback(fetchedFeedback);
  }, [fetchedFeedback]);

  const handleDownload = () => {
    if (!allstudentsfeedbackresponse || allstudentsfeedbackresponse.length === 0) {
      console.error('No feedback data available to download.');
      return;
    }

    const flattenedData = [];

    allstudentsfeedbackresponse.forEach((feedback) => {
      const { studentId, studentName, questions = [], answers = [] } = feedback;

      // Add Section A header
      flattenedData.push({ StudentID: '', StudentName: '', Question: 'Section A', Answer: '' });

      questions.forEach((question, index) => {
        flattenedData.push({
          StudentID: studentId,
          StudentName: studentName,
          Question: question,
          Answer: answers[index] || ''
        });

        if (index === 4) {
          flattenedData.push({ StudentID: '', StudentName: '', Question: 'Section B', Answer: '' });
        }

        if (index === 10) {
          flattenedData.push({ StudentID: '', StudentName: '', Question: 'Section C', Answer: '' });
        }

        // After last question, add 3 empty rows
        if (index === questions.length - 1) {
          for (let i = 0; i < 3; i++) {
            flattenedData.push({ StudentID: '', StudentName: '', Question: '', Answer: '' });
          }
        }
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(flattenedData);

    // Optional: Set column widths
    worksheet['!cols'] = [
      { wpx: 120 }, // StudentID
      { wpx: 200 }, // StudentName
      { wpx: 500 }, // Question
      { wpx: 200 }, // Answer
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Feedback');

    XLSX.writeFile(workbook, 'FeedbackData.xlsx');
  };




  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    // Filter the fetched feedback based on the search query
    const filtered = fetchedFeedback.filter((feedback) =>
      feedback.moduleName.toLowerCase().includes(query.toLowerCase())
    );

    setFilteredFeedback(filtered);
  };

  useEffect(() => {
    axios.get('batches')
      .then(response => {
        setBatchCodes(response.data);
      })
      .catch(error => {
        console.error('Error fetching batch codes:', error);
      });
  }, []);

  const handleBatchChange = (e) => {
    const selectedBatchCode = e.target.value;
    setSelectedBatch(selectedBatchCode);
    const batch = batchCodes.find(batch => batch.batchcode === selectedBatchCode);

    if (batch) {
      setSelectedBatchId(batch.id);
      // Fetch the batch details to get modules
      axios.get(`batch/${batch.id}`)
        .then(response => setModuleDetails(response.data.moduleDetails))
        .catch(error => console.error('Error fetching batch details:', error));

    } else {
      setSelectedBatchId(null);
      setModuleDetails([]);
    }
  };

  const handleCloseModal = () => {
    setShowCreateModal(false);

    setModuleName('');
    setDateTaken('');
    setLectureName('');
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };


  const handleCloseNestedModal = () => {
    setShowNestedModal(false);
  };


  //for delete created feedback
  const handleDelete = (id) => {
    const confirmed = window.confirm('Are you sure you want to delete the course feedback?');
    if (!confirmed) {
      return;
    }
    axios.delete(`generalfeedbackcreate/${id}`)
      .then(response => {
        setFetchedFeedback(prevFeedback => prevFeedback.filter(feedback => feedback.id !== id));
        toast.success('Feedback deleted successfully');
      })
      .catch(error => {
        console.error('Error deleting feedback data:', error);
      });
  };

  useEffect(() => {
    if (selectedBatchId) {
      fetchFeedbackByBatch(selectedBatchId);
    }
  }, [selectedBatchId]);

  const handleCreate = (e) => {
    e.preventDefault();
    const confirmed = window.confirm('Are you sure you want to save the course feedback?');
    if (!confirmed) {
      return;
    }

    const feedbackQuestions = [


      "My overall rating for the Course",
      "The duration was within reasonable time",
      "The Course was useful to my job",
      "The course materials were clear and comprehensive",
      "The Course has met my expectations",

      "The teacher has adequate knowledge and experience on the subject",
      "The teacher was well prepared and organized",
      "The teacher presented and communicated ideas, concepts and information clearly",
      "The teacher uses relevant examples and case studies",
      "The teacher encourages interaction and participation",
      "My overall rating of the teacher",

      "The Class venue is conveniently located",
      "The General Environment is",
      "The quality of the visual aid is clear",
      "The class size is just right",
      "Administrative & Management staffs are efficient",
      "My overall rating of the class administration",

    ];


    const feedbackData = {
      questions: feedbackQuestions,
      batchId: selectedBatchId,
      moduleName,
      dateTaken,
      // lectureName
    };

    axios.post('generalfeedbackcreate/', feedbackData)
      .then(response => {
        setShowCreateModal(false);
        toast.success('Course feedback created successfully');
        fetchFeedbackByBatch(selectedBatchId); // Fetch the updated feedback list after creation
        setModuleName('');
        setDateTaken('');
        // setLectureName('');
      })
      .catch(error => {
        console.error('Error creating feedback data:', error);
      });
  };

  useEffect(() => {
    if (selectedBatchId) {
      axios.get(`generalfeedbackcreate/batch/${selectedBatchId}`)
        .then(response => {
          setFetchedFeedback(response.data); // Set fetchedFeedback directly to response data array
          console.log(response.data);
        })
        .catch(error => {
          console.error('Error fetching feedback data for batch:', error);
          setFetchedFeedback([]); // Clear fetchedFeedback if an error occurs or no data is found
        });
    } else {
      setFetchedFeedback([]); // Clear fetchedFeedback when no batch is selected
    }
  }, [selectedBatchId]);

  const fetchFeedbackByBatch = (batchId) => {
    axios.get(`generalfeedbackcreate/batch/${batchId}`)
      .then(response => {
        setFetchedFeedback(response.data); // Set fetchedFeedback directly to response data array
        console.log(response.data);
      })
      .catch(error => {
        console.error('Error fetching feedback data for batch:', error);
      });
  };
  // for fecth feedback by feedback id
  const fetchFeedbackDetails = (feedbackId) => {
    // console.log(feedbackId)
    axios.get(`generalfeedback/feedback/${feedbackId}`)
      .then(response => {
        console.log(response.data)
        setDetailedFeedback(response.data);
        setSelectedFeedback(response.data);
        console.log(response.data.studentName)

        setShowViewModal(true); // Show the view modal after data is fetched
      })
      .catch(error => {
        console.error('Error fetching feedback details:', error);
      });
  };

  const deleteStudentfeed = (id) => {
    const confirmed = window.confirm('Are you sure you want to delete the course feedback?');
    if (!confirmed) {
      return;
    }
    axios.delete(`generalfeedback/${id}`)
      .then(response => {
        setSelectedFeedback(prevFeedback => prevFeedback.filter(feedback => feedback.id !== id));
        toast.success('Feedback deleted successfully');
      })
      .catch(error => {
        console.error('Error deleting feedback data:', error);
      });
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
    >
      <Box
        sx={{
          width: { xs: '100%', sm: '60%', md: '80%', lg: '70%' },
          backgroundColor: '#fff',
          borderRadius: 2,
          boxShadow: 3,
          padding: 3
        }}
      >
        <h2>Feedback Form</h2>

        <Box display="flex" justifyContent="space-between" mt={2} gap={2}>
          <Button variant="contained" onClick={openModal}>Feedback Statistics</Button>
          <FeedbackChartModal isOpen={isModalOpen} onClose={closeModal} feedbackData11={feedbackChartData} totalfeedbacksansweredcount={totalfeedbacksansweredcount} />
          <Button variant="contained" onClick={handleDownload}>Download Feedback</Button>
        </Box>

        <br />

        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2} mb={1}>
          <TextField
            label="Search by Question"
            value={searchQuery}
            onChange={handleSearch}
            variant="outlined"
            fullWidth
          />

          <FormControl variant="outlined" fullWidth>
            <InputLabel id="batchSelectLabel">Select Batch</InputLabel>
            <Select
              labelId="batchSelectLabel"
              id="batchSelect"
              value={selectedBatch}
              onChange={handleBatchChange}
              label="Select Batch"
            >
              <MenuItem value="">
                <em>Select a batch</em>
              </MenuItem>
              {batchCodes.map(batch => (
                <MenuItem key={batch.id} value={batch.batchcode}>
                  {batch.batchcode}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {selectedBatch && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setShowCreateModal(true)}
              sx={{ padding: '10px 35px', fontSize: '15px', whiteSpace: 'nowrap' }}
            >
              <FaPlus /> Create
            </Button>
          )}
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">S.No</TableCell>
                <TableCell align="center">Module Name</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredFeedback.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">No feedback found</TableCell>
                </TableRow>
              ) : (
                filteredFeedback.map((feedback, index) => (
                  <TableRow key={feedback.id}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="center">{feedback.moduleName}</TableCell>
                    <TableCell align="center">
                      <Button variant="contained" color="primary" onClick={() => fetchFeedbackDetails(feedback.id)}>
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Modal show={showCreateModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Create Feedback</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleCreate}>
              <div className="form-group">
                <label htmlFor="moduleName">Name of the Module Taken</label>
                <select
                  className="form-control"
                  id="moduleName"
                  value={moduleName}
                  onChange={(e) => setModuleName(e.target.value)}
                >
                  <option value="">Select a module</option>
                  {moduleDetails.length === 0 && (
                    <option disabled>No modules available for this batch</option>
                  )}
                  {moduleDetails.map(module => (
                    <option key={module.id} value={module.moduleName}>
                      {module.moduleName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="dateTaken">Date Taken</label>
                <input
                  type="date"
                  className="form-control"
                  id="dateTaken"
                  value={dateTaken}
                  onChange={(e) => setDateTaken(e.target.value)}
                />
              </div>
              <div>
                <button type="submit" style={{ backgroundColor: '#6c159d', color: 'white', padding: '5px 15px', marginTop: '10px' }}>Create</button>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        <Modal show={showViewModal} onHide={() => setShowViewModal(false)} dialogClassName="modal-fullscreen">
          <Modal.Header closeButton>
            <Modal.Title>Feedback Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S.No</TableCell>
                    <TableCell align="center">Student Name</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedFeedback.map((feedback, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center">{feedback.studentName}</TableCell>
                      <TableCell align="center">
                        <Box display="flex" gap={1} justifyContent="center">
                          <Button variant="contained" color="secondary" onClick={() => deleteStudentfeed(feedback.id)}>
                            <BsTrashFill />
                          </Button>
                          <Button variant="contained" color="primary" onClick={() => setShowNestedModal(true)}>
                            View
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Modal.Body>
        </Modal>

        <NestedModal showNestedModal={showNestedModal} handleCloseNestedModal={handleCloseNestedModal} detailedFeedback={detailedFeedback} />

        <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
      </Box>
    </Box>
  );
};

const Allstudent = () => {
  return (
    <div>
      <Header />

      <div classname="col-md-4 mb-1 py-1" style={{ marginTop: "1%", marginLeft: "2%" }}>

        <App />
      </div>

    </div>
  );
};

export default Allstudent;

